export const transitionTimingFunction = {
    ease: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
};
